import { Grid } from "@mui/material";
import { MetricBox } from "../../../ReusableComponents/MetricBox";
import { COMPONENT_SPACING } from "../../../../utils/constants/designConstants";
import { formatCurrency } from "../../../../utils/functions";

const buildMetrics = (spendOverview) => [
  {
    key: "total_spend",
    title: "Spend",
    total: formatCurrency(spendOverview?.total_spend),
  },
  {
    key: "supplier_count",
    title: "Supplier Count",
    total: spendOverview?.supplier_count ?? "-",
  },
];

export const SpendMetricsSection = ({ spendOverview }) => {
  const metrics = buildMetrics(spendOverview);
  return (
    <Grid container spacing={COMPONENT_SPACING.GRID_SPACING} sx={{ mb: 6 }}>
      {metrics.map((metric) => (
        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={metric.key}>
          <MetricBox
            title={metric.title}
            total={metric.total}
            variant="light"
          />
        </Grid>
      ))}
    </Grid>
  );
};
